import { Component, Input, OnInit } from "@angular/core";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { SegmentGroupType } from "@arch/_shared/types/company.types";
import { BenchmarkingEntity } from "@arch/domain/entity/benchmarking.entity";

@Component({
    selector: "app-report-card-benchmark",
    imports: [SharedMaterialModule],
    templateUrl: "./report-card-benchmark.component.html",
    styleUrl: "./report-card-benchmark.component.scss"
})
export class ReportCardBenchmarkComponent {
    @Input({ required: true }) benchmark: BenchmarkingEntity;
    @Input({ required: false }) locked: boolean = false;
    @Input({ required: false }) pdfMode: boolean = false;
}
